import React from "react";
import s from "./style.module.css";
import Page from "../../layouts/Page";
import Content from "../../components/Content";
import ContentBlock from "../../components/ContentBlock";
import ExternalLinkList from "../../components/ExternalLinkList";
import InternalNavigation from "../../components/InternalNavigation";
import DownloadBlock from "../../components/DownloadBlock";
import LaunchBanner from "../../components/LaunchBanner";
// import VideoEmbed from "../../components/VideoEmbed";
import ScrollToHash from "../../helpers/scrollToHash";
import useContent from "../../helpers/useContent";
import { SubHeading, Heading } from "../../components/Elements";
// import Container from "../../components/Container";
import { ReactComponent as Blogs } from "../../components/Icons/blogs.svg";
import { ReactComponent as DataAnalysis } from "../../components/Icons/dataanalysis.svg";
import { ReactComponent as Report } from "../../components/Icons/report.svg";
import { ReactComponent as Country } from "../../components/Icons/country.svg";
import { ReactComponent as Media } from "../../components/Icons/media.svg";
import Header from "./the-report-header.svg";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const TheReport = () => {
  const acknowledgements = useContent(copy.acknowledgements.content, {}, true);

  return (
    <Page
      meta={copy.meta}
      title={copy.title}
      intro={copy.intro}
      image={Header}
      fullImage
      footer={
        <div>
          <ContentBlock plain {...copy.acknowledgements} id="acknowledgements">
            <Content items={acknowledgements} />
          </ContentBlock>
        </div>
      }
      beforeHeader={
        <>
          {copy.banner?.text && (
            <LaunchBanner text={copy.banner.text} url={copy.banner.url} />
          )}
        </>
      }
    >
      <ScrollToHash />
      {copy.sections && <InternalNavigation items={copy.sections} />}

      <ContentBlock {...copy.reportOverview} icon={<Report />} id="download">
        {copy.reportOverview.parts.map(({ title, chapters }) => (
          <div key={title} className={s.part}>
            {title && (
              <div className={s.subHeading}>
                <Heading className={s.partTitle}>{title}</Heading>
              </div>
            )}

            {chapters.map((chapter, i) => (
              <DownloadBlock
                key={i}
                {...chapter}
                chapterCopy={copy.reportOverview.chapter}
                downloadCopy={copy.reportOverview.download}
              />
            ))}
          </div>
        ))}
      </ContentBlock>

      {copy.dataAndAnalysis && (
        <ContentBlock
          {...copy.dataAndAnalysis}
          icon={<DataAnalysis />}
          id="data-and-analysis"
        >
          <ExternalLinkList items={copy.dataAndAnalysis.links} />
        </ContentBlock>
      )}

      {copy.research && (
        <ContentBlock
          {...copy.research}
          icon={<Blogs />}
          id="background-research"
        >
          <ExternalLinkList items={copy.research.links} />
        </ContentBlock>
      )}

      {copy.countryCaseStudies && (
        <ContentBlock
          {...copy.countryCaseStudies}
          id="country-case-studies"
          icon={<Country />}
        >
          <ExternalLinkList items={copy.countryCaseStudies.links} />
        </ContentBlock>
      )}

      {copy.media && (
        <ContentBlock {...copy.media} id="media" icon={<Media />}>
          <div className={s.subHeading}>
            <SubHeading className={s.groupTitle}>Videos</SubHeading>
          </div>
          <ExternalLinkList items={copy.media.links} />

          <div className={s.subHeading}>
            <SubHeading className={s.groupTitle}>Blogs</SubHeading>
          </div>
          <ExternalLinkList items={copy.media.blogs} />
        </ContentBlock>
      )}
    </Page>
  );
};

export default TheReport;
